import clsx from "clsx";
import { ReactNode } from "react";
import styles from "./index.module.css";

const IntroContainer = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div className={clsx(styles.introContainer, className)}>{children}</div>
  );
};

export default IntroContainer;
